import React from 'react';
import QuickLink from './QuickLink';

export default ({ employee: { employee_code, uuid } }) => (
  <div className="quick-links mb-3">
    <QuickLink resourceName="employees" filters={{ recruited_by: uuid }}>
      Medewerkers
    </QuickLink>
    <QuickLink resourceName="applicants" accessPath="employees" filters={{ recruited_by: uuid }}>
      Sollicitanten
    </QuickLink>
  </div>
);
